import { useDispatch, useSelector } from "react-redux";
import { openRegistrationModal, closeRegistrationModal } from "../store";
import { RootReduxState } from "~/modules/app/components/ReduxProvider/types";
import * as Analytics from "../analytics";

// // // //

type AnalyticsEventProps = {
    label: string;
    properties: Record<string, string>;
};

export function useRegistrationModal(): {
    isOpen: boolean;
    open: (analyticsProps: AnalyticsEventProps) => void;
    close: () => void;
} {
    const dispatch = useDispatch();
    const isOpen = useSelector(
        (state: RootReduxState) => state.auth.isRegistrationModalOpen,
    );

    function onClickOpen(analyticsProps: AnalyticsEventProps) {
        Analytics.trackInlineRegistrationModalOpen(analyticsProps);
        dispatch(openRegistrationModal());
    }

    function onClickClose() {
        dispatch(closeRegistrationModal());
    }

    return {
        isOpen,
        open: onClickOpen,
        close: onClickClose,
    };
}
